module.exports = __webpack_public_path__ + "img/room-size-icon.9753ec81.svg";